import Button from 'components/button/Button';
import { black, white } from 'modules/colors';
import { spacing } from 'modules/metrics';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const LogoArea = styled.div<{ bgColor?: 'dark' | 'white' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${spacing.lg}px;
`;

export const IconsWrapper = styled.div<{ bgColor?: 'dark' | 'white' }>`
  width: 800px;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.bgColor === 'dark' ? `${black}` : `${white}`};

  border-radius: ${spacing.md}px;

  > * {
    margin: ${spacing.lg}px;
  }

  transition: background-color ease-in-out 0.5s;
`;

export const Bid2boardLogo = styled.img`
  height: 56px;
`;

export const ButtonStyled = styled(Button)`
  margin-top: ${spacing.xl}px;
`;

export const Text = styled.span`
  margin-top: 100px;
`;
